import errorManager from '@/rollbar.js';

const createChannels = (url, fileName, channel_name) => {
  const ps = new BroadcastChannel(`ep_channel::pdf_preview_sender::${channel_name}`);
  const pr = new BroadcastChannel(`ep_channel::pdf_preview_receiver::${channel_name}`);
  ps.onmessage = () => {
    pr.postMessage({ url, fileName });
  };
};

const openPreviewPage = (channel_name) => {
  const pdf_preview_url = `${window.config.ePersonamService.ePersonamHost}/it/prints/pdf_preview?ch=${channel_name}`;
  window.open(pdf_preview_url, '_blank');
};

const openPreview = (preview_selector, e) => {
  const doc = preview_selector.querySelector('a');
  const fileName = doc.getAttribute('title');
  const fileExt = fileName.split('.').pop();
  const validImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
  const href = doc.getAttribute('href');

  if (fileExt == 'pdf') {
    e.preventDefault();
    createPreview(href, fileName);
  } else if (!validImageExtensions.includes(fileExt)) {
    e.preventDefault();
    alert('Formato non supportato per la preview');
  }
};

const setListener = (selector) => {
  document.querySelector(selector).addEventListener('click', (e) => {
    const isPreviewButton = e.target.classList.contains('fa-eye');
    if (isPreviewButton) {
      const activator = e.target.classList.contains('.preview_activator') ? e.target : e.target.closest('.preview_activator');
      openPreview(activator, e);
    }
  });
};

export const createPreview = (href, fileName) => {
  const channel_name = Math.random().toString(36).slice(2);
  createChannels(href, fileName, channel_name);
  openPreviewPage(channel_name);
};

const init = (selector) => {
  try {
    setListener(selector);
  } catch (error) {
    errorManager(error);
  }
};

window.filePreview = {
  init: init,
};
